import React, { useReducer } from 'react';
import PropTypes from 'prop-types';
import useFeedAnalytics from '../../hooks/useFeedAnalytics';
import {
  pageProps,
  viewingAthleteProps,
  cursorDataProps,
  feedTypeProps,
  indexProps,
  timeAndLocationProps
} from '../../props/feed-prop-types';
import FeedEntityContext from '../../state/FeedEntityContext';
import { init, reducer } from '../../state/feed-entity-reducer';
import { buildInitialState } from '../../state/feed-entity-init-state';

import PerformanceGoalSingleView from '../shared/PerformanceGoalSingleView';
import PerformanceGoalMultiView from '../shared/PerformanceGoalMultiView';

const PerformanceGoalCreated = ({
  entity,
  viewingAthlete,
  clubId,
  page,
  feedType,
  index,
  cursorData,
  rowData,
  athleteProfileId,
  timeAndLocation
}) => {
  const { trackAnalytics, intersectionObserverRef } = useFeedAnalytics({
    page,
    entity,
    entityId: rowData.goal_entries[0].entity_id,
    athleteProfileId,
    feedType,
    index,
    viewingAthleteId: viewingAthlete.id,
    clubId
  });

  const [entityState] = useReducer(
    reducer,
    buildInitialState({
      trackAnalytics
    }),
    init
  );

  const providerState = {
    entityState
  };

  const bodyProps = {
    entity,
    intersectionObserverRef,
    index,
    cursorData,
    viewingAthlete,
    shareable: rowData.goal_entries[0].shareable,
    twitterUrl: rowData.goal_entries[0].twitter_url,
    isBoosted: rowData.goal_entries[0].is_boosted,
    timeAndLocation,
    goalEntries: rowData.goal_entries,
    entityId: rowData.goal_entries[0].entity_id
  };

  return (
    <FeedEntityContext.Provider value={providerState}>
      {rowData.goal_entries.length > 1 ? (
        <PerformanceGoalMultiView {...bodyProps} />
      ) : (
        <PerformanceGoalSingleView {...bodyProps} />
      )}
    </FeedEntityContext.Provider>
  );
};

PerformanceGoalCreated.propTypes = {
  entity: PropTypes.oneOf(['PerformanceGoalCreated']).isRequired,
  viewingAthlete: viewingAthleteProps.isRequired,
  clubId: PropTypes.string.isRequired,
  athleteProfileId: PropTypes.string.isRequired,
  page: pageProps.isRequired,
  cursorData: cursorDataProps.isRequired,
  feedType: feedTypeProps.isRequired,
  index: indexProps.isRequired,
  timeAndLocation: timeAndLocationProps.isRequired,
  rowData: PropTypes.shape({
    goal_entries: PropTypes.arrayOf(
      PropTypes.shape({
        shareable: PropTypes.bool,
        is_boosted: PropTypes.bool,
        twitter_url: PropTypes.string.isRequired,
        entity_id: PropTypes.number.isRequired,
        description: PropTypes.string.isRequired,
        athlete_feed_entry_id: PropTypes.number.isRequired,
        athlete_id: PropTypes.number.isRequired
      })
    )
  }).isRequired
};

export default PerformanceGoalCreated;
